import { isDefined } from "@clipboard-health/util-ts";
import semVer from "semver";

import { getDeviceInfo } from "../lib/utils/capacitor/deviceUtils";

export async function isDeviceEligibleForLiveActivities() {
  const deviceInfo = await getDeviceInfo();

  if (deviceInfo.platform !== "ios") {
    return false;
  }

  const osVersion = semVer.coerce(deviceInfo.osVersion);

  // We check manually that the os version is 16.2 or greater here.
  // We had tried using semver.gte() but it was not working as expected.
  if (osVersion?.major === 16) {
    return osVersion?.minor && osVersion.minor >= 2;
  }

  return isDefined(osVersion?.major) && osVersion.major > 16;
}
